module.exports = __webpack_public_path__ + "fe5775f7ca7d43c12135d2ccae90ed06.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Regular.ttf
// module id = 987
// module chunks = 0